import { ECourseContentStep, ECourseStep } from '@/types';

export const ManagerBaseContentDetailTranslations = {
  BASE_CONTENT: {
    es: 'Contenido base',
    en: 'Base content',
    cat: 'Contingut base',
    eus: 'Edukiak base',
    pt: 'Conteúdo base'
  },
  [ECourseStep.CONTENT]: {
    es: 'Contenido',
    en: 'Content',
    cat: 'Contingut',
    eus: 'Edukiak',
    pt: 'Conteúdo'
  },
  [ECourseContentStep.INTRODUCTION]: {
    es: 'Introducción',
    en: 'Introduction',
    cat: 'Introducció',
    eus: 'Sarrera',
    pt: 'Introdução'
  },
  [ECourseContentStep.SECTIONS]: {
    es: 'Secciones',
    en: 'Sections',
    cat: 'Seccions',
    eus: 'Sekzioak',
    pt: 'Seções'
  },
  [ECourseStep.TASKS_PANEL]: {
    es: 'Panel de tareas',
    en: 'Tasks panel',
    cat: 'Panell de tasques',
    eus: 'Lanen panela',
    pt: 'Painel de tarefas'
  },
  [ECourseStep.QUIZZES]: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Tests',
    eus: 'Testak',
    pt: 'Testes'
  },
  CREATE_SECTION: {
    es: 'Crear sección',
    en: 'Create section',
    cat: 'Crear secció',
    eus: 'Sekzioa sortu',
    pt: 'Criar seção'
  },
  CREATE_INTRODUCTION_SECTION: {
    es: 'Crear introducción',
    en: 'Create introduction',
    cat: 'Crear introducció',
    eus: 'Sarrera sortu',
    pt: 'Criar introdução'
  },
  IMPORT_SECTION: {
    es: 'Importar sección',
    en: 'Import section',
    cat: 'Importar secció',
    eus: 'Sekzioa inportatu',
    pt: 'Importar seção'
  },
  IMPORT_ACTIVITY: {
    es: 'Importar actividad',
    en: 'Import activity',
    cat: 'Importar activitat',
    eus: 'Jarduera inportatu',
    pt: 'Importar atividade'
  },
  COURSE_SELECTOR_LABEL: {
    es: 'Selecciona un curso de origen:',
    en: 'Select a source course:',
    cat: "Selecciona un curs d'origen:",
    eus: 'Hautatu jatorrizko ikastaro bat:',
    pt: 'Selecione um curso de origem:'
  },
  NO_SECTIONS_AVAILABLE: {
    es: 'Este curso no tiene secciones disponibles',
    en: 'This course has no available sections',
    cat: 'Aquest curs no té seccions disponibles',
    eus: 'Ikastaro honek ez du sekziorik eskuragarri',
    pt: 'Este curso não tem seções disponíveis'
  },
  NO_ACTIVITIES_IN_SECTION: {
    es: 'Esta sección no tiene actividades',
    en: 'This section has no activities',
    cat: 'Aquesta secció no té activitats',
    eus: 'Sekzio honek ez du aktibitaterik',
    pt: 'Esta seção não tem atividades'
  },
  EDIT_SECTION: {
    es: 'Editar sección',
    en: 'Edit section',
    cat: 'Editar secció',
    eus: 'Sekzioa editatu',
    pt: 'Editar seção'
  },
  EDIT_INTRODUCTION_SECTION: {
    es: 'Editar introducción',
    en: 'Edit introduction',
    cat: 'Editar introducció',
    eus: 'Sarrera editatu',
    pt: 'Editar introdução'
  },
  EMPTY_CONTENT_TITLE: {
    es: 'Empieza a construir tu curso',
    en: 'Start building your course',
    cat: 'Comença a construir el teu curs',
    eus: 'Hasi zure ikastaroa eraikitzen',
    pt: 'Comece a construir seu curso'
  },
  EMPTY_CONTENT_DESCRIPTION: {
    es: 'Crea secciones o importa contenido de otros cursos para avanzar más rápido.',
    en: 'Create sections or import content from other courses to move faster.',
    cat: "Crea seccions o importa contingut d'altres cursos per avançar més ràpid.",
    eus: 'Sortu sekzioak edo inportatu beste ikastaro batzuetako edukiak azkarrago aurrera egiteko.',
    pt: 'Crie seções ou importe conteúdo de outros cursos para avançar mais rápido.'
  },
  NAME_LABEL: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  DESCRIPTION_LABEL: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  NAME_PLACEHOLDER: {
    es: 'Añade un título',
    en: 'Add a title',
    cat: 'Afegeix un títol',
    eus: 'Gehitu titulu bat',
    pt: 'Adicione um título'
  },
  DESCRIPTION_PLACEHOLDER: {
    es: 'Escribe aquí...',
    en: 'Write here...',
    cat: 'Escriu aquí...',
    eus: 'Idatzi hemen...',
    pt: 'Escreva aqui...'
  },
  CONFIRM_SAVE_TITLE: {
    es: 'Cambios en contenido sincronizado',
    en: 'Changes in content synchronized',
    cat: 'Canvis en contingut sincronitzats',
    eus: 'Edukiak sinkronizatuak',
    pt: 'Alterações no conteúdo sincronizadas'
  },
  CONFIRM_SAVE_DESCRIPTION: {
    es: 'Estás editando contenido sincronizado.',
    en: 'You are editing synchronized content.',
    cat: 'Estàs editant contingut sincronitzat.',
    eus: 'Sinkronizatutako edukia editatzen ari zara.',
    pt: 'Está a editar conteúdo sincronizado.'
  },
  SINGLE_SYNCED_COURSE: {
    es: 'Este cambio se reflejará en el curso <bold>{{courseName}}</bold>',
    en: 'This change will be reflected in the course <bold>{{courseName}}</bold>',
    cat: 'Aquest canvi es reflectirà en el curs <bold>{{courseName}}</bold>',
    eus: 'Aldaketa honek ikastarora <bold>{{courseName}}</bold> batera eragiten du',
    pt: 'Esta alteração será refletida no curso <bold>{{courseName}}</bold>'
  },
  MULTIPLE_SYNCED_COURSES: {
    es: 'Este cambio se reflejará en los siguientes cursos que usan este contenido:',
    en: 'This change will be reflected in the following courses that use this content:',
    cat: 'Aquest canvi es reflectirà en els cursos següents que utilitzen aquest contingut:',
    eus: 'Aldaketa honek ikastaro hauek eragiten ditu:',
    pt: 'Esta alteração será refletida nos cursos seguintes que utilizam este conteúdo:'
  },
  ACTIVITIES_one: {
    es: '{{ count }} actividad',
    en: '{{ count }} activity',
    cat: '{{ count }} activitat',
    eus: '{{ count }} jarduera',
    pt: '{{ count }} atividade'
  },
  ACTIVITIES_other: {
    es: '{{ count }} actividades',
    en: '{{ count }} activities',
    cat: '{{ count }} activitats',
    eus: '{{ count }} jarduera',
    pt: '{{ count }} atividades'
  },
  SEARCH_SECTIONS_BY_NAME: {
    es: 'Buscar secciones por nombre',
    en: 'Search sections by name',
    cat: 'Buscar seccions per nom',
    eus: 'Sekzioak izena bilatzeko',
    pt: 'Buscar seções por nome'
  },
  SEARCH_SECTIONS_OR_ACTIVITIES_BY_NAME: {
    es: 'Buscar secciones o actividades por nombre',
    en: 'Search sections or activities by name',
    cat: 'Buscar seccions o activitats per nom',
    eus: 'Sekzioak edo jarduerak izena bilatzeko',
    pt: 'Buscar seções ou atividades por nome'
  },
  SEE_MORE_COURSES: {
    es: 'Ver {{remainingCourses}} más',
    en: 'See {{remainingCourses}} more',
    cat: 'Veure {{remainingCourses}} més',
    eus: 'Ikusi {{remainingCourses}} gehiago',
    pt: 'Ver mais {{remainingCourses}}'
  },
  SYNCED_COURSES_ERROR_TITLE: {
    es: 'No se pudo verificar el contenido sincronizado',
    en: 'Could not verify synchronized content',
    cat: "No s'ha pogut verificar el contingut sincronitzat",
    eus: 'Ezin izan da sinkronizatutako edukia egiaztatu',
    pt: 'Não foi possível verificar o conteúdo sincronizado'
  },
  SYNCED_COURSES_ERROR_DESCRIPTION: {
    es: 'No se pudo cargar la información de cursos sincronizados. Si guardas cambios, podrían afectar a otros cursos sin advertencia. Por favor, verifica tu conexión y vuelve a intentarlo.',
    en: 'Could not load synchronized courses information. If you save changes, they might affect other courses without warning. Please check your connection and try again.',
    cat: "No s'ha pogut carregar la informació de cursos sincronitzats. Si deses els canvis, podrien afectar a altres cursos sense advertència. Si us plau, verifica la teva connexió i torna-ho a intentar.",
    eus: 'Ezin izan da sinkronizatutako ikastaroen informazioa kargatu. Aldaketak gordetzen badituzu, beste ikastaro batzuei ere eragina izan lezake ohartarazpenik gabe. Mesedez, egiaztatu zure konexioa eta saiatu berriro.',
    pt: 'Não foi possível carregar informações de cursos sincronizados. Se salvar alterações, elas podem afetar outros cursos sem aviso. Por favor, verifique sua conexão e tente novamente.'
  },
  IMPORT_SECTION_ALERT: {
    es: 'Solo puedes importar secciones de un curso a la vez.',
    en: 'You can only import sections from one course at a time.',
    cat: "Només pots importar seccions d'un curs a la vegada.",
    eus: 'Ikastaro batetik bakarrik inporta ditzakezu sekzioak aldi berean.',
    pt: 'Só pode importar seções de um curso de cada vez.'
  },
  IMPORT_ACTIVITY_ALERT: {
    es: 'Solo puedes importar actividades de un curso a la vez.',
    en: 'You can only import activities from one course at a time.',
    cat: "Només pots importar activitats d'un curs a la vegada.",
    eus: 'Ikastaro batetik bakarrik inporta ditzakezu jarduerak aldi berean.',
    pt: 'Só pode importar atividades de um curso de cada vez.'
  },
  SELECT_ALL: {
    es: 'Seleccionar todo',
    en: 'Select all',
    cat: 'Seleccionar tot',
    eus: 'Dena hautatu',
    pt: 'Selecionar tudo'
  },
  SYNCED_CONTENT_MODAL_DESCRIPTION: {
    es: 'Estás editando contenido sincronizado. Los cambios que hagas se reflejarán en todos los tests sincronizados.',
    en: 'You are editing synchronized content. The changes you make will be reflected in all synchronized tests.',
    cat: 'Estàs editant contingut sincronitzat. Els canvis que facis es reflectiran en tots els tests sincronitzats.',
    eus: 'Sinkronizatutako edukia editatzen ari zara. Aldaketak testak batera eragiten du.',
    pt: 'Está a editar conteúdo sincronizado. As alterações que fizer serão refletidas em todos os testes sincronizados.'
  },
  SYNCED_CONTENT_MODAL_CHECKBOX: {
    es: 'Entiendo que los cambios afectarán a todos los tests sincronizados.',
    en: 'I understand that changes will affect all synchronized tests',
    cat: 'Entenc que els canvis afectaran a tots els tests sincronitzats',
    eus: 'Ulertzen dut aldaketak sinkronizatutako testak guztiei eragingo diela',
    pt: 'Entendo que as alterações afetarão todos os testes sincronizados'
  }
};
